var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollapse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.844 9.428h2.585a1 1 0 010 2h-.001l-4.975-.002a1 1 0 01-1-.995l-.024-4.997a1 1 0 01.995-1.005h.005a1 1 0 011 .995l.012 2.578 3.28-3.28a1 1 0 111.415 1.414l-3.292 3.292zM5.433 13.429l4.997.025a1 1 0 01.995.999l.004 4.975a1.001 1.001 0 01-2 .002l-.002-2.585-3.291 3.291a1 1 0 01-1.414-1.414l3.279-3.28-2.577-.013a1 1 0 01.005-2h.004z",
    fill: "current"
  })));
}
export default SvgCollapse;